import { actionTypes, Types } from "../../context/action/action";
import store from "../../context/store/store";
import {
  chats, chatSocketReducerStateModel, chatwindowDetails, contacts, contactSync, contactwindowDetails, LoginState
} from "../../models/model";
import {
  Cookie,
  enablePermission,
  enablePermissionSafari,
  getcontactDetail, ParseRecentFilterData,
  presence,
  scrollIntoView,
  setCookie
} from "../utils";
import axios from "axios";
import { showNotification } from "../notification";
import { toastInformation } from "../callService/common";
import { config } from "../constant";
import { SocketChatService } from "../socketChatService";
import { userInfo } from "../socketChatService/utils";
import { eventService } from "../eventService/event.service";
import { chatSideWindow,saveBlockUnblock } from "../eventService/eventApiService";
import { updateMeetingTotalBatch } from "../meetingService/apiService";
import { createCallConnection } from "../callService/callService";
import { contactService } from "../contactService";
import { uuidv4 } from "../meetingService/utils/meetingServices";
import { LoginService } from "../loginService";
import { Session } from "inspector";

var _ = require('lodash');


//let authKey = getCookie("ssoToken");
export class ChatService {

  public static async parseSavedChat(saved: any) {
    let responseArray: any = ParseRecentFilterData(saved, "saverecent");
    let { isSavedPageLoad,
      isSavedPaginationStop }: any = store.getState().recentchatReducer;
    store.dispatch({
      type: Types.SET_SAVED_CHAT,
      payload: {
        savedContact: responseArray
      }
    });
    store.dispatch({
      type: Types.SAVED_LOAD,
      payload: {
        savedPageLoad: false,
        isSavedPageLoad: isSavedPageLoad,
        isSavedPaginationStop: isSavedPaginationStop
      }
    });
  }

  public static async openContactWindow(contactDetails: any) {
    // store.dispatch({
    //   type: Types.EMPTY_CHATWINDOWDETAILS,
    //   payload: {
    //   }
    // });
  }
  public static async onChangeEditWindow(status: boolean, editMessagedetails: any) {
    let details: any = {};
    details.isEditing = status;
    details.message = status ? editMessagedetails : { id: "", text: "" };
    store.dispatch({
      type: Types.EDIT_MESSAGE_WINDOW,
      payload: {
        editMessageDetails: details
      }
    });

  }
  public static async selectedMessageDispatch(data: any) {
    let chatReducer: chats = store.getState().chatReducer;
    if (chatReducer?.isDelete || chatReducer?.multiOption) {
      let deletedArray: any = chatReducer?.selectMessageData;
      const indexLoc = await deletedArray.findIndex((value: any) => value.id === data.id);
      if (indexLoc > -1) {
        deletedArray?.splice(indexLoc, 1);
      } else {
        deletedArray?.push(data);
      }
      store.dispatch({
        type: Types.SELECT_MESSAGE_ARRAY,
        payload: {
          selectMessageData: deletedArray
        }
      });
    }
  }

  public static async saveallMessage(message: any, contacts: any, fileDescr?: string) {
    const userDetails = userInfo();
    const socketChat = new SocketChatService(userDetails.fromID, userDetails.domainId);

    message.forEach((message: any) => {

      //  if (!_.isUndefined(message?.message?.isSave)) {
      let issBookmark: any = message?.message?.isSave || [];
      let savedBookmark = (issBookmark && issBookmark["s" + userDetails?.fromID]) || 0;
      let isBookmark = {
        id: message.id,
        saveStatus: savedBookmark === 0 ? 1 : 0
      };
      socketChat.bookMarkMesseage(isBookmark);
      // }
    });
    toastInformation('Message Saved successfully', 'success');
  }

  public static async forwardMessage(message: any, contacts: any, fileDescr?: string) {
    const userDetails = userInfo();
    const socketChat = new SocketChatService(userDetails.fromID, userDetails.domainId);
    message.forEach((message: any) => {
      contacts.forEach((list: any) => {
        if (list?.sip_login_id) {
          if (message?.message?.messageType === "FILE" || message?.message?.messageType === "IMAGE") {
            if (fileDescr) {
              const fileName = message?.message?.body?.fileName;
              const filePath = message?.message?.body?.filePath;
              const fileType = message?.message?.body?.fileType;
              const fileSize = message?.message?.body?.filesize;
              socketChat.newMessageFileAttach(fileName, fileType, fileSize, filePath, list, false,
                fileDescr ? fileDescr : message?.message?.body?.text)
            } else {
              socketChat.forwardFileMessage(message, list);
            }
            // socketChat.newMessageFileAttach()
          } else {
            socketChat.NewChat(message?.message?.body, list, message);
          }
        } else {
          if (message?.message?.messageType === "FILE" || message?.message?.messageType === "IMAGE") {
            if (fileDescr) {
              message.message.body.text = fileDescr ? fileDescr : message?.message?.body?.text;
              socketChat.sendFileToGroup(message.message.body, list, false, message);
            } else {
              socketChat.sendFileToGroup(message.message.body, list, false, message);
            }
          } else {
            socketChat.forwardGroupMessage(message.message.body, list, message);
          }
        }
      });
    });
  };
  public static async newMessageHistory(id: any) {
    store.dispatch({
      type: Types.OPEN_CHAT_WINDOW,
      payload: {
        chatWindowDetails: id
      }
    });

  };

  public static async openChatWindow(InputcontactDetails: any, history?: any, contact?: any) {

    let chatReducer = store.getState().chatReducer;
    const chatService = new SocketChatService(userInfo().fromID, userInfo().domainId);
    chatService.openChatWindow(InputcontactDetails, history, contact, 'contactpage');

    if (chatReducer.isDelete) {
      ChatService.onChangeDeleteWindow(false, '');
    }
    if (chatReducer.isForward) {
      ChatService.onChangeForwardWindow(false, '');
    }

    history && history.push("/chats");

  };

  public static async editDraft(draftMsg: any) {

    store.dispatch({
      type: Types.EDIT_DRAFT,
      payload: {
        editDraft: draftMsg
      }
    });
  }


  public static async onDeleteMesage(message?: any) {
    const userDetails = userInfo();
    const socketChat = new SocketChatService(userDetails.fromID, userDetails.domainId);
    //let msg: any = message?.length > 1 ? message?.length + " Messages Deleted" : config().DELETEMESSAGE;
    let msg: any = config().DELETEMESSAGE;
    message.forEach((message: any) => {
      socketChat.deleteForEveryone(message?.id);
      if (!_.isUndefined(message?.message?.isSave) && message?.message?.isSave['s' + userDetails?.fromID] === 1) {
        let isBookmark = {
          id: message.id,
          saveStatus: 0
        };
        socketChat.bookMarkMesseage(isBookmark);
      }
    });
    toastInformation(msg, 'success');
  }

  /**
   * @description Get Stickers
   * @returns   
   */
  public static async getStcikers() {
    let token: string = store.getState().loginReducer.token;
    const url: string = "https://urapi.worktual.co.uk/urchat/v2/upload/get_stickers";
    var authkey = {
      "Content-Type": "application/json",
      Authorization: token
    };
    return axios
      .get(url, { headers: authkey })
      .then((res: any) => {
        store.dispatch({
          type: Types.GET_STICKERS,
          payload: {
            isStickers: true,
            stickers: res.data.stickers
          }
        });
      }
      );

  }

  public static async getDeactivateContact(data:any,isBlock:number) {
    let user :any = store.getState().loginReducer;
    const url: string = config().DEACTIVATED_URL;
    let headers = {
      "Content-Type": 'application/json'
      };
    let payload:any = {
      "extension": data?.ext,
      "status": isBlock === 1? 1 :0,
      "action_type": 2,
      "company_id": data?.company_id,
      "domain_id": user?.userdetails?.domain_id,
      "order_id": user?.userdetails?.order_id
    }

     return await axios.post(url,payload, {headers} ).then((resp:any)=>{
      if(resp?.data?.status_code === 200){
        let contactRed = store.getState().contactReducer;
        let { workContacts, allContacs, workContactsnew, allContactsNew,teamContacsnew,teamContacs}: any = contactRed;
        let { chatWindowDetails }: any = store.getState().chatWindowReducer;
           // workContacts[wIndex].is_blocked = 1
           let allContacsIndex = allContacs.findIndex((value: any) => value?.sip_login_id === parseInt(resp?.data?.finalresponse[0].sip_login_id));
           allContacs[allContacsIndex].is_blocked = isBlock === 1? 0 :1
         //  allContactsNew[allContacsIndex].is_blocked = 1;
         //  workContactsnew[resp?.data?.finalresponse[0].sip_login_id].is_blocked = 1;
           if(chatWindowDetails?.sip_login_id === parseInt(resp?.data?.finalresponse[0].sip_login_id)){
             chatWindowDetails['is_blocked'] = isBlock === 1? 0 :1
           }
           saveBlockUnblock(resp?.data?.finalresponse[0],payload);

          store.dispatch({
            type: Types.UPDATE_ALL_CONTACTS,
            payload: {
              allContactsNew: allContactsNew,
              teamContacsnew: teamContacsnew,
              teamContacs: teamContacs,
              workContactsnew: workContactsnew,
              allContacs: allContacs,
              workContacts: workContacts
            }
          })
      }
 
     })
     .catch((err:any)=> {
         console.log("error box-----------",err)
     })

  }

  public static async replyFileUpload(file: any) {
    let token: string = store.getState().loginReducer.token;
    let replyFileArray: any = [];
    let formData = new FormData();
    formData.append("doc", file);
    const url: string = `${config().CHAT_RESTAPI_URL}/upload/files`;
    var authkey = {
      "Content-Type": "application/json",
      Authorization: token
    };
    await axios
      .post(url, formData, { headers: authkey })
      .then((response: any) => {
        if (response.data && response.data.statusCode === 200) {
          let fileInfo: any = {
            fieldname: response.data.files[0].fieldname,
            filename: response.data.files[0].filename,
            geturl: response.data.files[0].geturl,
            mimetype: response.data.files[0].mimetype,
            size: response.data.files[0].size
          };
          replyFileArray.push(fileInfo);

          store.dispatch({
            type: Types.FILE_LIST,
            payload: {
              fileList: replyFileArray
            }
          });
        }
        else {
          toastInformation(config().FILEUPLOADFAIL, 'failure');
          store.dispatch({
            type: Types.FILE_UPLOAD_PROGRESS_BAR,
            payload: {
              fileUpload: false
            }
          });
          store.dispatch({
            type: Types.FILE_LIST,
            payload: {
              fileList: []
            }
          });
        }
      }
      );
  }
  /**
   * @description File Upload in API
   * @param file 
   */
  public static async fileUpload(file: any) {
    let chatSocketReducerState: chatSocketReducerStateModel = store.getState().chatSocketReducerState;
    let chatReducer: chats = store.getState().chatReducer;
    if (chatReducer.editMessageDetails?.isEditing) {
      toastInformation("Can't attach new file while editing", 'success');
      return;
    }
    let fileAttachArray: Array<any> = chatSocketReducerState.filesAttach || [];
    const fileAttachtemp = fileAttachArray;
    if (file && fileAttachtemp.length < 10) {
      fileAttachtemp.push(file);
      store.dispatch({
        type: actionTypes.FILE_ATTACHMENTS,
        payload: {
          filesAttach: fileAttachtemp
        }
      });
    }
  }



  public static async onChangeReplyWindow(status: boolean, replyMessagedetails: any) {

    const newReplay = Object.assign({}, replyMessagedetails) || [];
    if (status) {
      newReplay.fromcaller_details = newReplay.from;
    }
    let details: any = {};
    details.isReply = status;
    details.replyType = replyMessagedetails?.message_type_value;
    details.replySelectFile = "";
    details.replyFileType = "";
    details.replyFileName = "";
    details.replyFileSize = "";
    details.replyFileMimeType = "";

    details.replymessage = status ? newReplay : {};

    store.dispatch({
      type: Types.REPLY_MESSAGE_WINDOW,
      payload: {
        replyMessageDetails: details
      }
    });

  }


  public static async openNotification(messages: any) {


    try {

      let { userdetails }: LoginState = store.getState().loginReducer;
      let { allContacs }: contacts = store.getState().contactReducer;

      let caller_details = getcontactDetail(messages?.from.split("@"), allContacs, userdetails);


      let isMute: any = 0;
      if (caller_details?.team_id)
        isMute = caller_details?.Mute_Notification;
      else
        isMute = caller_details?.is_muted;

      if (messages?.body_text && !isMute) {

        let msgtxt: any = messages?.body_text;
        if (messages?.message_type_value === "FILE" || messages?.subject_text === "FILE") {

          msgtxt = "Shared a file";
        } else if (messages?.message_type_value === "EVENT" || messages?.subject_text === "EVENT") {

          msgtxt = "Shared a event";
        }
        if (messages?.message_type_value === "NOTE" || messages?.subject_text === "NOTE") {

          msgtxt = "Shared a notes";
        } else if (messages?.message_type_value === "TASKS" || messages?.subject_text === "TASKS") {

          msgtxt = "Shared a task";
        } else if (messages?.message_type_value === "TEXT" || messages?.subject_text === "TEXT") {

          msgtxt = messages?.body_text;
        }

        let inputOptions = {
          userName: `${caller_details?.caller_id}`,
          message: msgtxt,
          id: caller_details,
          type: 'call'
        };
        if (caller_details?.caller_id !== undefined) {
          showNotification(inputOptions);
        }
      }

    } catch (error) {
      console.log("openNotification error>>>>", error);
    }



  }



  public static async updateUserPresence(data: any) {
    try {
      let sipid = data && data.from.split("@")[0];

      let int_sipid = parseInt(sipid);

      let { allContacs, workContacts }: any = store.getState().contactReducer;



      let { recentContact }: any = store.getState().recentchatReducer;

      let { chatWindowDetails }: chatwindowDetails = store.getState().chatWindowReducer;



      let index: number = _.findIndex(allContacs, function (all: any) { return all.sip_login_id === int_sipid; });

      let cindex: number = _.findIndex(workContacts, function (work: any) { return work.sip_login_id === int_sipid; });


      let rindex: number = _.findIndex(recentContact, function (recent: any) { return recent.receiver === sipid; });


      let userPresence = "";

      switch (data.show_text) {
        case "chat":
          userPresence = "Available";
          break;
        case "away":
          userPresence = "Busy";
          break;
        case "dnd":
          userPresence = "Do not disturb";
          break;
        case "xa":
          userPresence = "Invisible";
          break;
        default:
          userPresence = "Invisible";
          break;
      }

      if (index !== -1) {
        allContacs[index].user_status = userPresence;
      }

      if (cindex !== -1) workContacts[cindex].user_status = userPresence;

      if (rindex !== -1) recentContact[rindex].presence = userPresence;


      store.dispatch({
        type: Types.WORK_CONTACT,
        payload: {
          workContacts: workContacts
        }
      });


      store.dispatch({
        type: Types.ALL_CONTACT,
        payload: {
          allContacs: allContacs
        }
      });


      store.dispatch({
        type: Types.SET_RECENT_CHAT,
        payload: {
          recentContact: recentContact
        }
      });

      if (chatWindowDetails?.sip_login_id === sipid) {
        chatWindowDetails.user_status = userPresence;

        store.dispatch({
          type: Types.OPEN_CHAT_WINDOW,
          payload: {
            isChatWindow: true,
            chatWindowDetails: chatWindowDetails,
            isMySpace: false
          }
        });
      }

    } catch (err) {
      console.error(err);
    }
  };



  public static async taskList(mode: any) {

    let { userdetails }: LoginState = store.getState().loginReducer;
    let { chatWindowDetails }: chatwindowDetails = store.getState().chatWindowReducer;
    let sipId = (chatWindowDetails.team_id || chatWindowDetails.team_id_prefix ? chatWindowDetails.team_id
      : chatWindowDetails.sip_login_id);
    let type = userdetails.sip_login_id === chatWindowDetails.sip_login_id ? 3 : chatWindowDetails.team_id ? 2 : 1;
    return new eventService().getTasklist(sipId, type).then((data: any) => {
      store.dispatch({
        type: Types.GET_TASK_LIST,
        payload: {
          isTask: true,
          taskLoader: false,
          taskListDetails: data.result.reverse(),
          taskDefaultCount: data.total_count
        }
      });
      return data;
    }).catch(() => {

    });
  };

  public static async eventList(mode: any) {
    let { userdetails }: LoginState = store.getState().loginReducer;
    let { chatWindowDetails }: chatwindowDetails = store.getState().chatWindowReducer;
    let sipId = (chatWindowDetails.team_id || chatWindowDetails.team_id_prefix ?
      chatWindowDetails.team_id
      : chatWindowDetails.sip_login_id);
    let type = userdetails.sip_login_id === chatWindowDetails.sip_login_id ? 3 : chatWindowDetails.team_id ? 2 : 1;

    return new eventService().getEventlist(sipId, type).then((data: any) => {
      store.dispatch({
        type: Types.GET_EVENT_LIST,
        payload: {
          isEvent: true,
          eventLoader: false,
          eventListDetails: data.result
        }
      });
      return data;
    }).catch(() => {

    });

  };

  public static async notesList(mode: any) {

    let { userdetails }: LoginState = store.getState().loginReducer;
    let { chatWindowDetails }: chatwindowDetails = store.getState().chatWindowReducer;
    let sipId = (chatWindowDetails.team_id || chatWindowDetails.team_id_prefix ?
      chatWindowDetails.team_id
      : chatWindowDetails.sip_login_id);
    let type = userdetails.sip_login_id === chatWindowDetails.sip_login_id ? 3 : chatWindowDetails.team_id ? 2 : 1;
    return new eventService().getNotelist(sipId, type).then((data: any) => {
      store.dispatch({
        type: Types.GET_NOTES_LIST,
        payload: {
          isNotes: true,
          notesListDetails: data?.result,
          notesDefaultCount: data?.total_count
        }
      });
      return data;
    }).catch(() => {

    });


  };


  public static async receiveAddRemoveMember(contact: any) {



    let { chatWindowDetails }: chatwindowDetails = store.getState().chatWindowReducer;


    if (!chatWindowDetails || !chatWindowDetails.team_members || contact.x_status_code === "104") return true;

    if (chatWindowDetails?.jid?.split("@")[0] === contact?.from?.split("@")[0]) {

      let team_members = chatWindowDetails?.team_members.split(",");




      if (contact.x_item_affiliation === "member") {

        let membersArray = contact.x_item_jid.split(",");

        team_members = team_members.concat(membersArray);



        let membersDetails = chatWindowDetails.teammembersdetails;


        membersArray.map((member: any) => {


          let aindex: number = _.findIndex(membersDetails, { sip_login_id: member?.split("@")[0] });

          if (aindex === -1) {
            let userDetails = getcontactDetail(member?.split("@")[0]);
            membersDetails.push(userDetails);
            chatWindowDetails.teammembersdetails = membersDetails;
          }
        });


      } else if (contact.x_item_affiliation === "owner") {

      } else {

        team_members = _.filter(team_members, function (tobj: any) { return tobj !== contact.x_item_jid.split("@")[0]; });

        let membersDetails = chatWindowDetails.teammembersdetails;


        chatWindowDetails.teammembersdetails = _.filter(membersDetails, function (obj: any) { return obj.sip_login_id !== contact.x_item_jid.split("@")[0]; });
      }

      chatWindowDetails.team_members = team_members.join(",");

      store.dispatch({
        type: Types.OPEN_CHAT_WINDOW,
        payload: {
          isChatWindow: true,
          chatWindowDetails: chatWindowDetails,
          isMySpace: false
        }
      });




    }


  };


  public static async updateUserStatusMessage(data: any) {

    try {
      let sipid = data && data.from.split("@")[0];

      sipid = parseInt(sipid);
      let { workContacts, allContacs }: any = store.getState().contactReducer;


      let { recentContact, pinnedContact }: any = store.getState().recentchatReducer;

      let recentChatList = recentContact ? recentContact : [];
      let pinnedChatList = pinnedContact ? pinnedContact : [];
      let allContacts = Array.isArray(allContacs) ? allContacs : [];
      let workContacs = Array.isArray(workContacts) ? workContacts : [];
      let index: number = allContacts?.findIndex(
        (e: any) => e.sip_login_id === sipid
      );
      let cindex: number = workContacs?.findIndex(
        (e: any) => e.sip_login_id === sipid
      );
      let rindex: number = recentChatList?.findIndex(
        (e: any) => e.receiver === sipid.toString()
      );
      let pindex: number = pinnedChatList?.findIndex(
        (e: any) => e.receiver === sipid.toString()
      );
      let userPresence = data && data.status_text;

      if (index !== -1) {
        allContacts[index].status_msg = userPresence;
      }

      if (cindex !== -1) workContacs[cindex].status_msg = userPresence;
      if (rindex !== -1) {

        recentChatList[rindex].contactDetail.status_msg = userPresence;
      }


      if (pindex !== -1) {

        pinnedChatList[pindex].contactDetail.status_msg = userPresence;
      }

      store.dispatch({
        type: Types.WORK_CONTACT,
        payload: {
          workContacts: workContacs
        }
      });
      store.dispatch({
        type: Types.ALL_CONTACT,
        payload: {
          allContacs: allContacts
        }
      });

      store.dispatch({
        type: Types.SET_RECENT_CHAT,
        payload: {
          recentContact: recentChatList
        }
      });

      store.dispatch({
        type: Types.SET_PINNED_CHAT,
        payload: {
          pinnedContact: pinnedChatList
        }
      });
    } catch (err) {
      console.error(err);
    }
  };
  public static async updateUserPresencestatus(data: any) {
    let { chatWindowDetails }: chatwindowDetails = store.getState().chatWindowReducer;

    let { contactWindowDetails }: contactwindowDetails = store.getState().contactWindowReducer;
    try {
      let sipid = data && data.from.split("@")[0];

      sipid = parseInt(sipid);
      let { workContacts, allContacs }: any = store.getState().contactReducer;


      let { recentContact, pinnedContact }: any = store.getState().recentchatReducer;

      let recentChatList = recentContact ? recentContact : [];
      let pinnedChatList = pinnedContact ? pinnedContact : [];
      let allContacts = Array.isArray(allContacs) ? allContacs : [];
      let workContacs = Array.isArray(workContacts) ? workContacts : [];
      let index: number = allContacts.findIndex(
        (e: any) => e.sip_login_id === sipid
      );
      let cindex: number = workContacs.findIndex(
        (e: any) => e.sip_login_id === sipid
      );

      let rindex: number = recentChatList.findIndex(
        (e: any) => e.receiver === sipid.toString()
      );
      let pindex: number = pinnedChatList.findIndex(
        (e: any) => e.receiver === sipid.toString()
      );
      let userPresence = "";

      switch (data.show_text) {
        case "chat":
          userPresence = presence.AVAILABLE;
          break;
        case "away":
          userPresence = presence.BUSY;
          break;
        case "dnd":
          userPresence = presence.DISTRUB;
          break;
        case "xa":
          userPresence = presence.INVISIBLE;
          break;
        default:
          userPresence = presence.INVISIBLE;
          break;
      }

      if (index !== -1) {
        allContacts[index].user_status = userPresence;
      }

      if (cindex !== -1) workContacs[cindex].user_status = userPresence;

      if (rindex !== -1) recentChatList[rindex].contactDetail.user_status = userPresence;

      if (pindex !== -1) pinnedChatList[pindex].contactDetail.user_status = userPresence;
      if (chatWindowDetails.sip_login_id === sipid) {

        chatWindowDetails.user_status = userPresence;
        store.dispatch({
          type: Types.OPEN_CONTACT_WINDOW,
          payload: {

            contactWindowDetails: contactWindowDetails

          }
        });
      }
      if (contactWindowDetails?.sip_login_id === sipid) {
        contactWindowDetails.user_status = userPresence;
        store.dispatch({
          type: Types.OPEN_CHAT_WINDOW,
          payload: {

            chatWindowDetails: chatWindowDetails

          }
        });

      }



      store.dispatch({
        type: Types.WORK_CONTACT,
        payload: {
          workContacts: workContacs
        }
      });
      store.dispatch({
        type: Types.ALL_CONTACT,
        payload: {
          allContacs: allContacts
        }
      });


      store.dispatch({
        type: Types.SET_RECENT_CHAT,
        payload: {
          recentContact: recentChatList
        }
      });

      store.dispatch({
        type: Types.SET_PINNED_CHAT,
        payload: {
          pinnedContact: pinnedChatList
        }
      });

    } catch (err) {
      console.error(err);
    }
  };

  public static async onMultiOptionWindow(status: any) {
    store.dispatch({
      type: Types.MULTI_SELECT_OPTION,
      payload: {
        multiOption: status
      }
    });
  }

  public static async onChangeDeleteWindow(status: boolean, type: string) {
    let chatReducer: chats = store.getState().chatReducer;
    store.dispatch({
      type: Types.DELETE_MESSAGE_WINDOW,
      payload: {
        isDelete: status,
        deleteType: type
      }
    });
    if (!status || chatReducer?.isForward) {
      store.dispatch({
        type: Types.SELECT_MESSAGE_ARRAY,
        payload: {
          selectMessageData: []
        }
      });
    }
    if (chatReducer?.isForward) {
      store.dispatch({
        type: Types.FORWARD_MESSAGE_WINDOW,
        payload: {
          isForward: false,
          forwardType: ''
        }
      });
    }
  }


  public static async onChangeForwardWindow(status: boolean, type: string) {
    let chatReducer: chats = store.getState().chatReducer;
    store.dispatch({
      type: Types.FORWARD_MESSAGE_WINDOW,
      payload: {
        isForward: status,
        forwardType: type
      }
    });
    if (!status || chatReducer?.isDelete) {
      store.dispatch({
        type: Types.SELECT_MESSAGE_ARRAY,
        payload: {
          selectMessageData: []
        }
      });
    }
    if (chatReducer?.isDelete) {
      store.dispatch({
        type: Types.DELETE_MESSAGE_WINDOW,
        payload: {
          isDelete: false,
          deleteType: ''
        }
      });
    }
  }



  public static async emptyOnMyspace() {

    let loginDetails: LoginState = store.getState().loginReducer;
    store.dispatch({
      type: Types.OPEN_CHAT_WINDOW,
      payload: {
        isChatWindow: false,
        chatWindowDetails: loginDetails.userdetails,
        isMySpace: true
      }
    });
    store.dispatch({
      type: Types.CONTACT_FILES_LIST,
      payload: {
        isContactFile: false,
        contactFileList: []
      }
    });
    store.dispatch({
      type: Types.OPEN_NEW_MESSAGE,
      payload: {
        isNewMessageWindow: false,
        newUserMessage: [],
        newUserDetails: {}
      }
    });
    store.dispatch({
      type: Types.CONTACT_LINK_LIST,
      payload: {
        contactLinkList: []
      }
    });

    store.dispatch({
      type: Types.CONTACT_SAVED_LIST,
      payload: {
        contactSavedChatList: []
      }
    });
    store.dispatch({
      type: Types.GET_FILES_LIST,
      payload: {
        isfile: false,
        fileListDetails: []
      }
    });
    store.dispatch({
      type: Types.CHAT_FILE_LOAD,
      payload: {
        ischatfileLoad: false,
        contactfileLength: 0,
        ischatfileStopPagination: true
      }
    });
    store.dispatch({
      type: Types.CONTACT_FILE_LOAD,
      payload: {
        isfileLoad: false,
        contactfileLength: 0,
        isfileStopPagination: true
      }
    });

  }


  public static async saveChatHighlight(type: boolean, data: any) {
    store.dispatch({
      type: Types.SAVE_CHAT_MESSAGE,
      payload: {
        isSaveChat: type,
        saveChatData: data
      }
    });
    store.dispatch({
      type: Types.FILE_CHAT_MESSAGE,
      payload: {
        isviewContactFile: false,
        contactFileData: {}
      }
    });
    scrollIntoView(data?.id);
    setTimeout(() => {
      store.dispatch({
        type: Types.SAVE_CHAT_MESSAGE,
        payload: {
          isSaveChat: false,
          saveChatData: {}
        }
      });
    }, 2000);
  }

  public static async updateNavigation(navig: boolean) {
    store.dispatch({
      type: Types.CHECK_NAVIGATION,
      payloads: {
        navigation: navig
      }
    });
  }

  public static async filesHighlight(type: boolean, data: any) {
    store.dispatch({
      type: Types.FILE_CHAT_MESSAGE,
      payload: {
        isviewContactFile: type,
        contactFileData: data
      }
    });
    store.dispatch({
      type: Types.SAVE_CHAT_MESSAGE,
      payload: {
        isSaveChat: false,
        saveChatData: {}
      }
    });
  }

  public static async rightSideToogle() {
    let { isWindowSlide }: chats = store.getState().chatReducer;
    console.log('chat services ---', isWindowSlide);
    const chatwindowFrame = document.getElementById("frameinsection-resize") || null;
    if (chatwindowFrame) chatwindowFrame?.removeAttribute('style');
    chatSideWindow(!isWindowSlide, "", {});
  }

  public static async reInitsession() {

    const userInfo: any = Cookie.get();
    const userInfosess: any = sessionStorage.getItem("userinfo");

    if (userInfosess) return true;

    await LoginService.reInitUser().then(async (data) => {
      if (data && data.user_info) {


        store.dispatch({
          type: Types.ADD_LOGIN,
          payload: {
            userdetails: data.user_info
          }
        });
        // setStartScreen(false);

        // setCookie('userinfo', JSON.stringify(data.user_info), 365);
        sessionStorage.setItem("userinfo", JSON.stringify(data.user_info));

        // contactService.getTeamContact();
        //const userInfo = data?.user_info;
        //const service = new SocketChatService(userInfo?.sip_login_id, userInfo?.domain_id);
        const queryParams: contactSync = { ext: data.user_info.ext, CallId: uuidv4() };
        contactService.getWorkcontact(queryParams);
        createCallConnection(data.user_info);
        updateMeetingTotalBatch();


        if (navigator.userAgent.indexOf("Safari") !== -1 || navigator.userAgent.indexOf("Firefox") !== -1) {
          enablePermissionSafari('login');
        }
        else {
          enablePermission('login');
        }

        //}
      } else {

      }
    }).catch((err) => {

    });
  }
}
